import "./sw-alert.module.css";
import { html, LANGUAGE } from "../../global.ts";
import Strings from "../../../models/Strings.json";

const template = document.createElement("template");
template.innerHTML = html`
    <div
        id="sw-alert"
        onclick="heartbank.alertAdmin('footer/hide/alert')"
        tabindex="-1"
        class="transform translate-y-full transition-all duration-500 ease-out fixed bottom-0 start-0 z-[999] flex justify-between w-full p-4 border-t border-gray-200 dark:border-gray-600 bg-green-200">
        <div class="flex items-center mx-auto">
            <p
                id="sw-alert-info"
                class="flex items-center text-lg font-normal text-gray-500 dark:text-gray-400"></p>
        </div>
        <div class="flex items-center">
            <button
                title="${Strings.close[LANGUAGE]}"
                id="sw-alert-hide"
                data-dismiss-target2="#sw-alert"
                type="button"
                class="flex-shrink-0 inline-flex justify-center w-7 h-7 items-center text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 dark:hover:bg-gray-600 dark:hover:text-white">
                <svg
                    class="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14">
                    <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                </svg>
                <span class="sr-only">${Strings.close[LANGUAGE]}</span>
            </button>
        </div>
    </div>
`;

export default template;
